import React from 'react'
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react'
import PropTypes from 'prop-types'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'

export const MapCont = ({ google }, onMapClicked, onMarkerClick) => {
  const content = useContent(useDataQuery())

  const style = {
    width: '100%',
    height: '100%'
  }

  return (
    <Map
      // eslint-disable-next-line react/prop-types
      google={google}
      zoom={15}
      style={style}
      initialCenter={content.mapCenter}
      onClick={onMapClicked}
    >
      <Marker
        onClick={onMarkerClick}
        title={content.markerTitle}
        name={content.markerTitle}
        position={content.markerPosition}
      />
    </Map>
  )
}

MapCont.propTypes = {
  google: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDZZspKs5RpgXerC3ZuzjXSfBfTQ4pcWb4'
})(MapCont)
